import AppContext from "PFApp/app_context";
import { useSession } from "PFApp/use_session";
import { isSaasAdmin } from "PFCore/helpers/profile";
import { ApiRoute, UiRoute } from "PFCore/utilities/routes";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import css from "./sign_in_as_action.less";

const SignInAsAction = ({ user }) => {
  const { t } = useTranslation("admin", { keyPrefix: "users.list.actions" });
  const { getAccessToken } = useSession();
  const {
    store: { currentAccount }
  } = useContext(AppContext);

  const saasAdmin = isSaasAdmin(user);
  const isActive = !user.suspended && !user.hidden && user.employee_status === "active";

  if (saasAdmin || !isActive) {
    return "-";
  }

  return (
    <form method={"get"} action={ApiRoute("/api/oauth/authorize")} data-qa-id="SignInAsAction.form">
      <input type="hidden" name="redirect_uri" value={UiRoute("/")} />
      <input type="hidden" name="grant_type" value={"sign_in_as"} />
      <input type="hidden" name="response_type" value={"code"} />
      <input type="hidden" name="target_profile_id" value={user.id} />
      <input type="hidden" name="client_id" value={PF.config.client_id} />
      <input type="hidden" name="access_token" value={getAccessToken()} />
      <input type="hidden" name="account" value={currentAccount.full_domain} />

      <button className={css.button} data-qa-id="SignInAsAction.button">
        {t("signIn")}
      </button>
    </form>
  );
};

SignInAsAction.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    suspended: PropTypes.bool,
    employee_status: PropTypes.string,
    roles: PropTypes.array,
    hidden: PropTypes.bool
  })
};
export default SignInAsAction;
